module.exports = __webpack_public_path__ + "static/black_dragon-6a5f1d4d343c2c6bd926b4332d4b7d5d.jpg";